module.exports = [{"code":1,"name":"企业通行人员"},{"code":2,"name":"临时通行人员"},{"code":3,"name":"重点人员"}]


//////////////////
// WEBPACK FOOTER
// ./static/json/dictionary/personType.json
// module id = 77Q+
// module chunks = 11